exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "/* Example Media queries\n *\n * @media (max-width: @kng-screen-xs-max) { ... }\n * @media (min-width: @kng-screen-sm-min) and (max-width: @kng-screen-sm-max) { ... }\n * @media (min-width: @kng-screen-md-min) and (max-width: @kng-screen-md-max) { ... }\n * @media (min-width: @kng-screen-lg-min) { ... }\n *\n */\n.image-selector .img-option {\n  margin-right: 10px;\n  margin-bottom: 10px;\n  border: 5px solid #f2f2f2;\n  max-width: 220px;\n}\n.image-selector .img-option.selected {\n  border: 5px solid #ff6633;\n}\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// D:/dclean-web-latest/cot-web/src/app/components/areas/form/imageSelector.component.less
// module id = ../../../../../src/app/components/areas/form/imageSelector.component.less
// module chunks = main